// extracted by mini-css-extract-plugin
module.exports = {"photo":"User_photo__1CbVx","circle":"User_circle__18z_0","circle2":"User_circle2__3Jjdi","heart":"User_heart__1IOp6","line":"User_line__2op9w"};